import { render, staticRenderFns } from "./NewInputUsername.vue?vue&type=template&id=189b857c&scoped=true&"
import script from "./NewInputUsername.vue?vue&type=script&lang=js&"
export * from "./NewInputUsername.vue?vue&type=script&lang=js&"
import style0 from "./NewInputUsername.vue?vue&type=style&index=0&id=189b857c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b857c",
  null
  
)

export default component.exports